import { render } from "./modalPlusTimeReserve.vue?vue&type=template&id=18bc9094"
import script from "./modalPlusTimeReserve.vue?vue&type=script&lang=js"
export * from "./modalPlusTimeReserve.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__